import { createPageUrl } from '@/utils/routing';

export const MYTHKIT_BRAND = 'Myth-Kit';

/**
 * Default mobile header title from the current path (before character/page overrides).
 * Home (`/`) stays the app brand per product preference.
 */
export function getDefaultPageTitle(pathname: string): string {
  const normalized = pathname.replace(/\/$/, '') || '/';

  if (normalized === '/') {
    return MYTHKIT_BRAND;
  }

  const map: Record<string, string> = {
    [createPageUrl('Compendium')]: 'Compendium',
    [createPageUrl('Rules')]: 'Rules',
    [createPageUrl('CharacterCreator')]: 'Create Character',
    [createPageUrl('CharacterCreatorRandomize')]: 'Random character',
    [createPageUrl('CharacterSheet')]: 'Character Sheet',
    [createPageUrl('LevelUp')]: 'Level Up',
    [createPageUrl('MyCharacters')]: 'My Characters',
    [createPageUrl('CombatTracker')]: 'Combat Tracker',
    [createPageUrl('EncounterBuilder')]: 'Encounter Builder',
    [createPageUrl('DMScreen')]: 'DM Screen',
    [createPageUrl('Campaigns')]: 'Campaigns',
    [createPageUrl('CampaignDetail')]: 'Campaign',
    [createPageUrl('Wiki')]: 'Wiki',
    [createPageUrl('Generators')]: 'Generators',
    [createPageUrl('Homebrew')]: 'Homebrew',
    [createPageUrl('SpellBook')]: 'Spell Book',
    [createPageUrl('NewPlayer')]: 'New Player',
    [createPageUrl('NewDM')]: 'New DM',
    [createPageUrl('Glossary')]: 'Glossary',
    [createPageUrl('Macros')]: 'Macros',
    [createPageUrl('More')]: 'Library & tools',
    [createPageUrl('Legal')]: 'Legal',
    [createPageUrl('Privacy')]: 'Privacy',
    [createPageUrl('Terms')]: 'Terms',
    '/login': 'Log in',
    '/upgrade': 'Upgrade',
    '/upgrade/success': 'Upgrade',
    '/upgrade/complete': 'Upgrade',
    '/forgot-password': 'Forgot password',
    '/reset-password': 'Reset password',
  };

  if (map[normalized]) {
    return map[normalized];
  }

  if (/^\/campaigns\/[^/]+\/join\/?$/.test(normalized)) {
    return 'Join campaign';
  }

  return MYTHKIT_BRAND;
}
